import { useUser } from '../..';
import { AuthAccountResponseType } from '../../../api';

export function useUserDataMap() {
  const { setUser } = useUser();
  return (user: AuthAccountResponseType) => {
    setUser({
      id: user.id,
      role: user.userRole,
      firstName: user.firstName,
      lastName: user.surname,
      email: user.email || user.emailAddress,
      companyTradingName: user.companyTradingName,
      brokerUserId: user.brokerUserId,
      companyId: user.companyId,
    });
  };
}
